let swatchHeight = document.querySelector('.swatch_options').offsetHeight;
let quickAddBoxes = document.querySelectorAll('.Size');
let qabHeight = quickAddBoxes[1].offsetHeight;
if (qabHeight == 0) qabHeight = 62;
let addOn = 50;
if (!document.querySelector('.promo-text')) addOn = 20;
let offset = swatchHeight + qabHeight + addOn;

quickAddBoxes.forEach(qab => {
  qab.style = `bottom: ${offset}px;`;
});

/*
let quickAddBoxes = document.querySelectorAll('.Size');
let thumbHeight = document.querySelector('.thumbnail').offsetHeight;
let offset = thumbHeight - thumbHeight * 0.28;
quickAddBoxes.forEach(qab => {
  qab.style = `top: ${offset}px;`;
});
*/
